import { FieldType as FormFieldType, PicklistValue } from '@/components/Form';
import {
  adaptFormDataFunction,
  adaptFormFieldFunction,
  isFormDataValidFunction,
  parseFormDataFunction,
} from '@/modules/corporate/modules/database/fields/types';
import { adaptDatabaseFieldFunction } from '@/modules/corporate/modules/database/fields/types';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';

import { getNewSelectFieldOption } from '../../utils/metadataField';

export const getPicklistValues = (field: FieldType): PicklistValue[] => {
  if (!field.metadataField.options) {
    return [];
  }

  return field.metadataField.options.map((option) => ({
    value: option.optionId,
    label: option.value,
  }));
};

export const adaptFormData: adaptFormDataFunction = (data) => {
  return data?.value ? data.value.split(',')[0] : '';
};

export const adaptFormField: adaptFormFieldFunction = ({ field, t }) => ({
  type: FormFieldType.Picklist,
  size: 'large',
  placeholder: t('Common:Actions.Select'),
  picklistValues: getPicklistValues(field),
});

export const isFormDataValid: isFormDataValidFunction = (data) => Boolean(data?.length);

export const parseFormData: parseFormDataFunction = (value: string) => {
  return {
    value: value ? value : '',
  };
};

export const adaptSelectField: adaptDatabaseFieldFunction = ({ metadataField, viewField }) => {
  const options = metadataField.options;

  return {
    metadataField: {
      ...metadataField,
      options: options?.length ? options : [getNewSelectFieldOption({ value: '' })],
    },
    viewField,
  };
};
